var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavBarStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71468 0.878115C6.80449 0.601722 7.19551 0.601722 7.28532 0.878115L8.50424 4.62959C8.54441 4.75319 8.65959 4.83688 8.78956 4.83688H12.7341C13.0247 4.83688 13.1455 5.20877 12.9104 5.37959L9.71923 7.69812C9.61409 7.77452 9.57009 7.90993 9.61025 8.03353L10.8292 11.785C10.919 12.0614 10.6026 12.2912 10.3675 12.1204L7.17634 9.80188C7.07119 9.72548 6.92881 9.72548 6.82366 9.80188L3.63247 12.1204C3.39736 12.2912 3.08101 12.0614 3.17082 11.785L4.38975 8.03353C4.42991 7.90993 4.38591 7.77452 4.28077 7.69812L1.08957 5.37959C0.854459 5.20877 0.975292 4.83688 1.26591 4.83688H5.21044C5.34041 4.83688 5.45559 4.75319 5.49576 4.62959L6.71468 0.878115Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarStar);
export default __webpack_public_path__ + "static/media/nav_bar-star.957058306bb03648cc02ecba8ce96759.svg";
export { ForwardRef as ReactComponent };